module.exports = __webpack_public_path__ + "static/media/mobile-warning-hand.39f9292a.svg";